import { useState } from "react";
import moment from "moment";

export const useCategorizedList = ({
  business,
  filters,
  category
}) => {
  const type = filters?.type?.length === 1 ? filters.type[0] : ""
  const [state, setState] = useState({
    isLoading: true,
    invoiceList: [],
    totalInvoiceCount: 0,
  });

  const getDateRange = (date) => ({
    start: date?.startDate
      ? moment(date.startDate).startOf("day").valueOf()
      : undefined,
    end: date?.endDate
      ? moment(date.endDate).endOf("day").valueOf()
      : undefined,
  });

  const handleInvoice = async ({ limit, offset }) => {
    const { date, amount, keywords,sort } = filters || {};
    setState((prev) => ({ ...prev, isLoading: true }));
    const { start, end } = getDateRange(date);
    try {
      let totalInvoiceCount = state.totalInvoiceCount;

      // TOTALS (optimized like quickSale)
      let rawData;
      const baseQuery = business.getUncategorizedInvoice(
        start,
        end,
        keywords || "",
        type,
        undefined,
        undefined,
        amount,
        category,
        sort
      );

      rawData = await baseQuery.unsafeFetchRaw();
      // overall count (no filter)
      totalInvoiceCount = await business
        .getUncategorizedInvoice(
          null,
          null,
          "",
          type,
          undefined,
          undefined,
          undefined,
          category,
          sort

        )
        .fetchCount();
      // PAGINATION (same pattern as quickSale)
      const paginatedItems = await business
        .getUncategorizedInvoice(
          start,
          end,
          keywords || "",
          type,
          limit,
          offset,
          amount,
          category,
          sort
        )
        .fetch();
      const updatedList =
        offset > 0
          ? [...state.invoiceList, ...paginatedItems]
          : paginatedItems;

      setState((prev) => ({
        ...prev,
        isLoading: false,
        invoiceList: updatedList,
        totalInvoiceCount,
      }));
    } catch (error) {
      console.error(error);
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  return { ...state, handleInvoice };
};
